import { TerminalError } from "@/utils/UTerminal";

import { TCommandArg } from "@/types";

export const stringArg = (
	props?: Partial<TCommandArg>,
	errorMessage: string = "invalidString"
): TCommandArg => ({
	name: "string",
	description: "A string",
	check: (value) => {
		if (typeof value !== "string") {
			throw new TerminalError(errorMessage, {
				value,
			});
		}
		return true;
	},
	...props,
});
